import WebProvider from "./WebProvider";

let selectedProvider = null;
let BaseUrl = "";

const appType = window.vidyoApp?.getMode?.() === 0 ? "DESKTOP" : "WEB";

export const getCCModerationProvider = () => {
  if (selectedProvider) {
    return selectedProvider;
  }
  switch (appType) {
    case "DESKTOP":
      //selectedProvider = new DesktopProvider();
      break;

    case "WEB":
      selectedProvider = new WebProvider(BaseUrl);
      break;

    default:
      // selectedProvider = new WebProvider();
      break;
  }

  return selectedProvider;
};

export const setURL = (url) => {
  BaseUrl = url;
};
